// extracted by mini-css-extract-plugin
module.exports = {"cp-modal-partnership__preview__container":"styles_cp-modal-partnership__preview__container__3kumf","cp-modal-partnership__preview":"styles_cp-modal-partnership__preview__PHdno"};